import { render, staticRenderFns } from "./CieloSelectItem.vue?vue&type=template&id=1039960a&scoped=true"
import script from "./CieloSelectItem.vue?vue&type=script&lang=js"
export * from "./CieloSelectItem.vue?vue&type=script&lang=js"
import style0 from "./CieloSelectItem.vue?vue&type=style&index=0&id=1039960a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1039960a",
  null
  
)

export default component.exports